var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { class: _vm.classes, attrs: { href: "/" } }, [
    _c(
      "svg",
      {
        staticClass: "teaming-letter-logo__icon",
        attrs: {
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M11.2323 12.6843C17.4141 12.6843 22.4646 17.7348 22.5051 23.9571V38.7045H17.4949V23.9571C17.4949 20.4823 14.6667 17.6944 11.2323 17.6944C7.79798 17.6944 5.0101 20.5227 5.0101 23.9571V38.7045H0L0 23.9571C0 17.7348 5.0101 12.6843 11.2323 12.6843ZM11.1919 1.25C13.8182 1.25 15.9596 3.39141 15.9596 6.01768C15.9596 8.64394 13.8182 10.8258 11.1919 10.8258C8.56566 10.8258 6.46465 8.64394 6.46465 6.01768C6.46465 3.39141 8.56566 1.25 11.1919 1.25Z",
            fill: "#3D4EAC"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M28.7273 12.7281C34.9091 12.7281 39.9596 17.7786 40 24.0008V38.7483H34.9899V24.0008C34.9899 20.5261 32.1616 17.7382 28.7273 17.7382C25.2929 17.7382 22.505 20.5665 22.505 24.0008V38.7483H17.4949V24.0008C17.4949 17.7786 22.505 12.7281 28.7273 12.7281ZM28.6869 1.29376C31.3131 1.29376 33.4545 3.43518 33.4545 6.06144C33.4545 8.6877 31.3131 10.8291 28.6869 10.8291C26.0606 10.8695 23.9596 8.6877 23.9596 6.06144C23.9596 3.43518 26.0606 1.29376 28.6869 1.29376Z",
            fill: "#6C8EEF"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75e193b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e193b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DuoToneTeamingLetterLogo.vue
// module id = zfFv
// module chunks = 5